import React from 'react';
import axios from 'axios';
import {
    Link
  } from 'react-router-dom';
  import { Grid } from 'antd-mobile';
  import AppHeader from './../AppHeader';

var moment = require('moment');
//var moment = require('moment');

class WinnerTopTentwoDListPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            game_type : 1,
            step: "login",
            message : "",
            data : [
                {
                      first_name : "",
                      phone : "0923232333333",
                      win_amount : 0,
                      product_type : 1,
                }
            ],
            game_contest:{"id":48,"gcontest_id":38,"gcontest_name":" ","gcontest_type":1,"gcontest_set":"1,619.54","gcontest_value":"16,816.64","lottery_number":"46","num_prize":1,"payment_status":3,"commission_status":1,"schedule_at":"2022-11-25 11:00:00","start_date":"2022-11-24 17:00:00","expire_date":"2022-11-25 10:55:00","date_group":"2022-11-25","payment_second_chk":2,"commission_second_chk":1,"created_at":"2022-11-24T10:30:02.000000Z","updated_at":"2022-11-25T04:49:01.000000Z","deleted_at":null},
            setting:[{"option_id":8,"option_name":"minimum_amount","option_value":"10","autoload":"yes"},{"option_id":9,"option_name":"twod_multiple","option_value":"70","autoload":"yes"},{"option_id":10,"option_name":"threed_multiple","option_value":"300","autoload":"yes"},{"option_id":11,"option_name":"twod_commission","option_value":"5","autoload":"yes"},{"option_id":12,"option_name":"twod_maximum_amount","option_value":"5000","autoload":"yes"},{"option_id":13,"option_name":"threed_maximum_amount","option_value":"5000","autoload":"yes"}]
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.currencyFormat = this.currencyFormat.bind(this);
    }

    hisUrl(url) {
        if(localStorage.getItem("route")) {
          let menu = JSON.parse(localStorage.getItem("route"));
          //console.log(menu.length+"-------------")
          if(menu.length === "0") {
            let data = ["/"];
            localStorage.setItem("route", JSON.stringify(data) );
          }
           if(menu.length > 0) {
              //console.log(menu[menu.length - 1] + "-" + url )
                if(menu[menu.length - 2] === url ){
                    //console.log("first");
                    menu.pop();
                    //window.BPdata.route = JSON.stringify(menu);
                    localStorage.setItem("route", JSON.stringify(menu) );
                    //localStorage.setItem("route", JSON.stringify(menu) );
                }
                else if(menu[menu.length-1] !== url ){
                    menu.push(url)
                    //window.BPdata.route = JSON.stringify(menu);
                    localStorage.setItem("route", JSON.stringify(menu) );
                }
                window.BPdata.preurl =  menu[menu.length-2];
            }
        }
      }

    currencyFormat(num) {
        let n = parseFloat(num);
        if (isNaN(n)) { return num; }
        return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
    }

    getAnnouncementsApi() {

        let dataurl = window.BPdata.apiUrlCMS+'/winner-top-ten-list?type='+this.state.game_type;
        let data = this.state.data;
        var self = this;
        // axios({
        //     method: 'get',
        //     url: dataurl,
        //     data: data,
        //     headers: {
        //       "Content-Type": "application/json; charset=utf-8",
        //         "X-Trident-Token" : window.BPdata.token,
        //         "BP-Agent"        : window.BPdata.rand_compound,
        //         "BP-Time"         : localStorage.getItem(window.BPdata.time)
        //       // "Content-Type": "application/x-www-form-urlencoded",
        //   },
        // })
        axios.get(dataurl, {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          mode: "no-cors", // no-cors, cors, *same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          //credentials: "same-origin", // include, *same-origin, omit
          crossDomain: true,
          headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-Trident-Token" : window.BPdata.token,
              "BP-Agent"         : window.BPdata.rand_compound,
                "BP-Time"         : localStorage.getItem(window.BPdata.time)
              // "Content-Type": "application/x-www-form-urlencoded",
          },
          redirect: "follow", // manual, *follow, error
          referrer: "no-referrer", // no-referrer, *client
          //body: JSON.stringify(data), // body data type must match "Content-Type" header
        })
        .then(function (response) {
            if(response.data.data) {

                // console.log(response.data.data)

                if(response.data.data.data){

                    self.setState({
                        data : response.data.data.data,
                        setting : response.data.setting,
                        game_contest : response.data.game_contest,
                    });

                    // console.log('--------')
                    //
                    //
                    // console.log(response.data.game_contest)

                }

                // localStorage.setItem("noti", JSON.stringify(response.data.data) )
                //self.setState({  message : "Successfully updated" });
                //console.log(response.data.data)
            } else {
                self.setState({  message : "Something was wrong" });
            }
            //console.log(response.data.success);
        })
        .catch(function (error) {
            //console.log(error);
        });

          // console.log(this.state.game_contest)


    }



    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'radio' ? target.checked : target.value;
        let rev_value;
        if(value) {
            value     = 1;
            rev_value = 0;
        } else {
            value     = 0;
            rev_value = 1;
        }
        const name = target.name;
        let str = this.state.contests;
        // console.log(name)
        // console.log(name.split("-").length)

        if(name.split("-").length>0) {
            let word  = name.split("-");
            let first = word[0];
            let id    = word[1];
            console.log(first)
            if(first === "per_result1") {
                str[id].per_result1 = value;
                str[id].per_result2 = rev_value;
            }

            if(first === "per_result2") {
                str[id].per_result2 = value;
                str[id].per_result1 = rev_value;
            }

            if(first === "over") {
                str[id].over = value;
                str[id].under = rev_value;
            }

            if(first === "under") {
                str[id].under = value;
                str[id].over = rev_value;
            }

        }



        this.setState({contests:str});
        //console.log(name)
        // this.setState({
        //   [name]: value
        // });
        console.log(this.state.contests)
    }

    podiumItem(each, rank) {
        let medal = (rank === 1) ? '#FFD700' : (rank === 2) ? '#C0C0C0' : '#CD7F32';
        let pedestal = (rank === 1) ? 'linear-gradient(180deg, #FFE680 0%, #b8860b 100%)'
                     : (rank === 2) ? 'linear-gradient(180deg, #f0f0f0 0%, #9aa0a6 100%)'
                     : 'linear-gradient(180deg, #e6ab7f 0%, #a05a2c 100%)';
        let isFirst = (rank === 1);
        let avSize = isFirst ? 74 : 58;
        let pedH = isFirst ? 80 : 54;
        return (
            <div style={{ flex: 1, maxWidth: '34%', textAlign: 'center' }}>
                <div style={{ fontSize: '22px', lineHeight: 1, height: '24px' }}>{ isFirst ? '👑' : '' }</div>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <img src={"/img/avator/"+each.avator} style={{ width: avSize, height: avSize, borderRadius: '50%', border: '3px solid '+medal, objectFit: 'cover', background: '#fff' }} />
                    <span style={{ position: 'absolute', bottom: '-6px', left: '50%', transform: 'translateX(-50%)', background: medal, color: '#000', fontWeight: 'bold', fontSize: '12px', width: '22px', height: '22px', lineHeight: '22px', borderRadius: '50%', boxShadow: '0 2px 4px rgba(0,0,0,0.4)' }}>{rank}</span>
                </div>
                <div style={{ color: '#fff', fontSize: isFirst ? '15px' : '13px', fontWeight: 'bold', marginTop: '10px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '0 2px' }}>{each.first_name}</div>
                <div style={{ color: '#bbb', fontSize: '11px' }}>{each.phone}</div>
                <div style={{ color: '#bbb', fontSize: '11px', marginBottom: '6px' }}>{window.lang.betgroup.bet_amount}: {this.currencyFormat(each.bet_amount)}</div>
                <div style={{ background: pedestal, height: pedH, borderRadius: '10px 10px 0 0', display: 'flex', flexDirection: 'column', justifyContent: 'center', boxShadow: '0 2px 6px rgba(0,0,0,0.35)' }}>
                    <span style={{ color: '#1a1a1a', fontWeight: 'bold', fontSize: isFirst ? '16px' : '14px' }}>{this.currencyFormat(each.win_amount)}</span>
                </div>
            </div>
        );
    }

    podiumBlock(data) {
        return (
            <div key="podium" style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', padding: '6px 4px 16px' }}>
                { data[1] ? this.podiumItem(data[1], 2) : <div style={{ flex: 1 }} /> }
                { data[0] ? this.podiumItem(data[0], 1) : <div style={{ flex: 1 }} /> }
                { data[2] ? this.podiumItem(data[2], 3) : <div style={{ flex: 1 }} /> }
            </div>
        );
    }

    listRow(each, rank) {
        return (
            <div key={rank} className="bp-card bp-card-row" style={{ margin: '0 8px 8px' }}>
                <div style={{ width: '24px', textAlign: 'center', color: '#FFE200', fontWeight: 'bold', fontSize: '14px' }}>{rank}</div>
                <img src={"/img/avator/"+each.avator} style={{ width: '38px', height: '38px', borderRadius: '50%', margin: '0 10px', objectFit: 'cover', background: '#fff' }} />
                <div style={{ flex: 1, textAlign: 'left', color: '#fff', overflow: 'hidden' }}>
                    <div style={{ fontSize: '13px', fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{each.first_name}</div>
                    <div style={{ fontSize: '11px', color: '#bbb' }}>{each.phone}</div>
                </div>
                <div style={{ width: '70px', textAlign: 'right', color: '#fff', fontSize: '12px' }}>{this.currencyFormat(each.bet_amount)}</div>
                <div style={{ width: '92px', textAlign: 'right', color: '#FFE200', fontWeight: 'bold', fontSize: '13px' }}>{this.currencyFormat(each.win_amount)}</div>
            </div>
        );
    }

    displayBlock( ) {
        let data = this.state.data
        let ui = []
        let number = 0 ;

        if(data.length  > 0){

            ui.push(this.podiumBlock(data));

            // data.forEach(function(each){

            // if(data.length === 0) {
            //     ui.push(<div className="text-center" key="0"><h2>အချက်အလက်များရှာမတွေ့ပါ။</h2></div>)
            //     return ui
            // }

            for (let i = 0; i < this.state.data.length; i++) {
                if (i < 3) { continue; }
                ui.push(this.listRow(data[i], i + 1));
           }


        }

        if(ui.length === 0) {
            ui.push(<div className="bp-empty" key="0"><h2>အချက်အလက်များရှာမတွေ့ပါ။</h2></div>)
        }

        return ui
    }

    componentDidMount() {

        window.scrollTo(0, 0);
        // console.log(mmph.normalizeInput('+၉၅၉၇၈၄၁၂၃၄၅၆')); // returns 09784123456
        // console.log(mmph.normalizeInput('+959784123456')); // returns 09784123456
        // console.log(mmph.getTelecomName('09978412345')); // returns Ooredoo
        // console.log(mmph.getPhoneNetworkType('09978412345')); // returns GSM
        // console.log(mmph.isValidMMPhoneNumber('09978412345')); // returns true if it meets Myanmar Phone
        if(localStorage.getItem(window.BPdata.time)) {
            if(localStorage.getItem(window.BPdata.time) !== "0" ) {
              this.setState({ step: "profile" });
            }

          }

        // if(localStorage.getItem('username')) {
        //         this.setState({
        //             form: {
        //                 username : localStorage.getItem('username')
        //             }
        //         });
        // }

        // localStorage.setItem(window.BPdata.time, 0);
        // localStorage.setItem('username', "");
        // else {
        //   localStorage.setItem(window.BPdata.time, 'profile');
        //   this.setState({ step: "home" });
        // }
        this.hisUrl('/more/2d-winner-top-ten-list');
        //localStorage.setItem('route', '/more/login');
        //console.log(localStorage.getItem('route'))
        this.getAnnouncementsApi();
    }

    // componentWillUpdate() {
    //     localStorage.setItem('route', '/more/login');
    //     console.log(localStorage.getItem('route'))
    // }

    render() {
        return (
            <div className="page">
                <div className="page-content">
                <AppHeader backLink="/two-game" titleType="3" title={window.lang.title.twod} isLoading="false" />

                    <div className="main-content text-center">

                        <div className="row winner-draw-header bp-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 8px 6px', width: 'auto' }}>
                          <div style={{ textAlign: 'left', minWidth: 0 }}>
                            <span style={{ color: '#fff', fontSize: '0.85rem' }}>{window.lang.BetListDetail.start}</span> <br />
                            <span className="color-theme-gold">{moment(this.state.game_contest.schedule_at, 'YYYY-MM-DD hh:mm:ss').format('DD.MM.YYYY hh:mm A')}</span>
                          </div>
                          <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: '12px' }}>
                            <span style={{ color: '#fff', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>{window.lang.BetListDetail.number}</span> <br />
                            <span className="color-theme-gold" style={{ fontSize: "24px", fontWeight: 'bold' }}>{this.state.game_contest.lottery_number}</span>
                          </div>
                        </div>
                        <div className="row text-left">
                            <br/>
                            {this.displayBlock()}
                        </div>
                      {/*  <div className="ant-back-footer">
                            <div class="ant-back-top">
                                <div class="ant-back-top-content">
                                    <Link to={window.BPdata.preurl} className="color-green" >
                                { (JSON.parse(localStorage.getItem("route")) !== null)
                                ? ((this.state.url !== "/" || JSON.parse(localStorage.getItem("route"))[JSON.parse(localStorage.getItem("route")).length-1] !== "/") ?  <img src="/img/back-arrow.png" alt="back" />: ""  ) : "" }
                                </Link>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </div>
                <footer  className="App-footer">

                  <div className="App-footer-inner">
                    {/* {window.BPdata.footerMenu} */}
                    <Grid data={window.lang.footer}
                        columnNum={5}
                        renderItem={dataItem => (

                          <Link to={dataItem.url} className="cont-wrap-link hvr-pulse-shrink" style={{width: '100%'}}>
                                { (window.BPdata.footerMenu === dataItem.check )  ? (dataItem.text == "My Profile") ?  <span className="color-white"><img src={dataItem.icon}  height="25px"/><br />{(this.checklogin()) ? dataItem.text : "Login / Register" }</span> : <span className="text-white"><img src={dataItem.icon_off}  height="25px"/><br /><span >{dataItem.text}</span> </span> : <span className="text-white"><img src={dataItem.icon}  height="25px"/><br />{dataItem.text} </span> }

                          </Link>
                        )}
                      />

                  </div>
                </footer>

            </div>
        );
    }
}

export default WinnerTopTentwoDListPage;
